export type TagType = {
    value: string;
    text: string;
};
export const tags = {
    photo: 'Фото',
    markshader: 'Маркшейдер',
    private: 'Личное',
    messoyakha: 'Мессояха',
    video: 'Видео',
    watch: 'Вахта',
};
